/**
 * Bloqueia rotas do ERP quando o usuário não tem permissão (inclui URLs digitadas diretamente).
 */

import { Navigate, useLocation } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'
import { canAccessErpRoute } from '../config/erpNavigation'
import { getFirstAccessibleRoute } from '../utils/getFirstAccessibleRoute'

function ErpRouteGuard({ children }) {
  const location = useLocation()
  const { hasPermission, hasModuleAccess, loading, isAdmin } = usePermissions()

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Carregando...</div>
  }

  const admin = Boolean(isAdmin)
  const ctx = {
    isAdmin: admin,
    permissionsLoading: loading,
    hasPermission,
    hasModuleAccess
  }

  if (!canAccessErpRoute(location.pathname, ctx)) {
    const fallback = getFirstAccessibleRoute(hasPermission, admin, false) || '/'
    return <Navigate to={fallback} replace />
  }

  return children
}

export default ErpRouteGuard
